<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			text: string;
			icon: SbImage;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<li
	use:editable={content}
	class="flex items-center gap-x-4 border-t border-brown-6 py-4 first:border-none lg:py-6"
>
	<Image
		class="h-8 w-8 select-none object-cover"
		src={content.icon.filename}
		alt={content.icon.alt}
		title={content.icon.title}
	/>
	<div
		class="flex flex-col gap-x-2 text-[16px]/[150%] tracking-[-0.16px] lg:text-[20px]/[140%] lg:tracking-[-0.2px]"
	>
		<div class="text-nowrap">{content.headline}</div>
		<div class="text-dark-grey/50">{content.text}</div>
	</div>
</li>
